module.exports = __webpack_public_path__ + "static/media/seller_header.d8f5dbd8.png";